import { rei } from "@/services/api"

class pagamentoService {

    static storePagamento (payload) {
        return rei.post('pagamento-store', payload)
          .then(res => res.data)
    }
    static storePagamentos (pedidos) {
      return rei.post('pagamentos-store', pedidos)
        .then(res => res.data)
    }

    static pagamentoImpressao (payload) {
      return rei.post('pagamentos-impressao', payload, { responseType: 'arraybuffer' }).then((res) => {
        let blob = new Blob([res.data], { type: 'application/pdf' })
        let url = window.URL.createObjectURL(blob)
  
        return url
      })
    }

    static updatePagamento (pedido) {
        return rei.post('pagamento-update', pedido)
          .then(res => res.data)
    }

    static deletePagamento (idPedido) {
        return rei.get(`pagamento-delete/${idPedido}`)
          .then(res => res.data)
    }
}

export default pagamentoService